export default __webpack_public_path__ + "static/toby_s-f94966ce805049a7b306c4434b3ff6ee.png";